import React from "react";
import {
  TeachingSetInterface,
  TeachingSetPinLocation,
} from "../../../interfaces/teaching-set.interface";
import {
  buildAdminMapViewUrl,
  getCoordinatesFromPinLocation,
} from "../../../utils/olaMap.util";

interface TeachingSetsListProps {
  sets: TeachingSetInterface[];
}

const resolveLocation = (
  location: TeachingSetInterface["location"]
): TeachingSetPinLocation | null => {
  if (!location || typeof location === "string") return null;
  return location;
};

const TeachingSetsList: React.FC<TeachingSetsListProps> = ({ sets }) => {
  if (!sets.length) {
    return (
      <p className="text-gray-500 text-sm mt-3 border-t border-gray-700 pt-3">
        No teaching sets.
      </p>
    );
  }

  return (
    <div className="mt-3 border-t border-gray-700 pt-3 space-y-3">
      {sets.map((set) => {
        const pinLocation = resolveLocation(set.location);
        const coords = getCoordinatesFromPinLocation(pinLocation);

        return (
          <div
            key={set._id}
            className="rounded-lg border border-gray-700 bg-gray-900/50 p-3 text-sm space-y-1.5"
          >
            <div className="flex justify-between items-start gap-2">
              <p className="text-yellow-400 font-semibold">{set.board}</p>
              <span className="text-xs bg-gray-700 px-2 py-0.5 rounded text-gray-300 capitalize shrink-0">
                {set.teachingMode}
              </span>
            </div>
            <p className="text-gray-400 text-xs">
              <span className="text-gray-500">Level:</span> {set.level || "N/A"}
            </p>
            <p className="text-gray-400 text-xs">
              <span className="text-gray-500">Stream:</span>{" "}
              {set.subjectStream || "N/A"}
            </p>
            <p className="text-gray-400 text-xs">
              <span className="text-gray-500">Subjects:</span>{" "}
              {set.subjects?.length ? set.subjects.join(", ") : "None"}
            </p>
            <p className="text-gray-400 text-xs">
              <span className="text-gray-500">Min booking:</span>{" "}
              {set.minimumClassBooking ?? "N/A"}
            </p>
            <p className="text-gray-400 text-xs">
              <span className="text-gray-500">Location:</span>{" "}
              {pinLocation?.formattedAddress || "No location"}
            </p>
            {coords ? (
              <button
                type="button"
                onClick={() =>
                  window.open(
                    buildAdminMapViewUrl(
                      coords.lat,
                      coords.lng,
                      14,
                      pinLocation?.formattedAddress
                    ),
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                className="mt-1 inline-flex items-center px-3 py-1.5 rounded-md text-xs font-medium bg-amber-500/20 text-amber-300 border border-amber-400/40 hover:bg-amber-500/30 transition"
              >
                View on Map
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default TeachingSetsList;
